import React from 'react';

import type { StatusTone } from '~shared/ui/status-badge';
import { StatusBadge } from '~shared/ui/status-badge';

import { format } from 'date-fns';

import type { PaymentStatus } from '../../model/payment';

type Props = {
  paymentStatus: PaymentStatus;
  paymentTimestampUTC: string;
};

const statusConfig: Record<PaymentStatus, { tone: StatusTone; label: string }> =
  {
    IN_PROGRESS: { tone: 'warning', label: 'In progress' },
    SETTLED: { tone: 'positive', label: 'Settled' },
  };

export const PaymentStatusUI = React.memo<Props>(
  ({ paymentStatus, paymentTimestampUTC }) => {
    const config = statusConfig[paymentStatus] as
      | { tone: StatusTone; label: string }
      | undefined;
    const { tone, label } = config ?? { tone: 'neutral', label: paymentStatus };
    const isPaymentSettled = paymentStatus === 'SETTLED';

    return (
      <div>
        <StatusBadge tone={tone}>{label}</StatusBadge>
        {isPaymentSettled && (
          <span className="mt-0.5 block typography-text-xs text-black/50">
            {format(new Date(paymentTimestampUTC), 'dd-MM-yyyy, hh:mm a')}
          </span>
        )}
      </div>
    );
  }
);
PaymentStatusUI.displayName = 'PaymentStatusUI';
